import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { style } from './alert-styles';

@customElement('sbk-alert')
export class AlertComponent extends LitElement {
    @property({type: String})
    variant: 'error' | 'success' = 'success';

    @property({type: String})
        // eslint-disable-next-line lit/no-native-attributes
    title: string = '';


    static get styles() {
        return style;
    }

    private getIconForStatus(status: string): string {
        return {
            'error': 'warning',
            'success': 'checkmark'
        }[status] || '';
    }

    render() {
        return html`
            <div class="alert ${this.variant === 'success' ? 'alert-success' : 'alert-error'}">
                <div class="icon-wrapper">
                    <sbk-icon size="40" class="alert-icon icon-background"
                              symbol=${this.getIconForStatus(this.variant)}></sbk-icon>
                </div>

                <div class="alert-content">
                    <span class="alert-title">${this.title}</span>
                    <span class="alert-message"><slot></slot></span>
                </div>
            </div>
        `;
    }
}
